import React, { useState } from "react";
import { Link, navigate } from "gatsby";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import useDisableDevTools from "../../components/useDisableDevTools";
import { capitalizeFirstLetter } from "../../utils";
import { getSearchResult } from "../../utils/api";
import "../../styles/global.css";
import { Alternate, PT } from "../../constant";

const Index = () => {
    useDisableDevTools()
    const [searchQuery, setSearchQuery] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleSearchChange = async (event) => {
        const query = event.target.value;
        setSearchQuery(query);
        setLoading(true);

        try {
            const data = await getSearchResult(query);
            const allResults = data.results.filter(
                item => item.media_type === 'movie' || item.media_type === 'tv'
            );
            setSearchResults(allResults);
            setLoading(false);
        } catch (err) {
            setError('Failed to load movie data. Please try again later.');
            setLoading(false);
        }
    };

    const handleClickSearch = (e) => {
        e.preventDefault();
        navigate(`/search`)
        localStorage.setItem('query', searchQuery);
    }

    const handleClickLink = (movieId) => {
        localStorage.setItem('movieId', movieId);
    }

    return (
        <>
            <Header currentPage={PT} />
            <main className="main-container container">
                <div className="svg-container">
                    <h1 to={PT} className="logo-h1">
                        FMovies
                    </h1>
                </div>

                <form className="input-group" onSubmit={handleClickSearch}>
                    <input
                        type="search"
                        className="input-field"
                        placeholder="Digite o nome do filme ou série"
                        onChange={handleSearchChange}
                        value={searchQuery}
                        required
                    />
                    <button className="btn btn-primary" type="submit">Pesquisar</button>
                </form>
                <div className="search-suggestions">
                    {loading &&
                        <div className="small-loader-wrapper"><span className="small-loader"></span></div>
                    }
                    {error && !searchResults && <div>{error}</div>}
                    {!loading && searchResults.map((movie) => (
                        <Link
                            to={`${movie.media_type === "movie" ? `/movie-details` : `/series-details`}`}
                            key={movie.id}
                            onClick={() => handleClickLink(movie?.id)}
                            className="search-item"
                        >
                            <span>
                                {`${movie.title || movie.name} ${capitalizeFirstLetter(movie.media_type)} (${new Date(movie.release_date || movie.first_air_date).getFullYear()})`}
                            </span>
                        </Link>
                    ))}
                </div>
                <Link to="/home/" className="btn-home-page">Ir para página inicial</Link>
                <div className="content-container">

                    <h2 className="content-title main-heading-title">FMovies – Assista Filmes Online Gratuitamente</h2>

                    <p><Link to={PT} className="link">FMovies</Link> é um site popular para assistir filmes e séries de TV gratuitamente e baixá-los no seu dispositivo. Oferecemos uma grande seleção, incluindo Bollywood e Hollywood, em alta qualidade. Você pode assistir a diversos gêneros como romance, ação, drama, comédia, terror e muito mais. Nossos usuários adoram o site FMovies pela interface fácil de usar e por ser totalmente gratuito. Basta abrir fmovies.com no seu navegador e assistir aos seus filmes e séries favoritos.</p>

                    <p>Nosso site é atualizado diariamente, para que você possa assistir facilmente às novidades. FMovies é um dos melhores sites de streaming que oferece acesso gratuito a filmes e séries sem assinatura. No site oficial FMovies, você pode assistir anime online gratuitamente em HD, com legendas e versões dubladas. Nos esforçamos para proporcionar a melhor experiência aos visitantes. Com filmes de alta qualidade, oferecemos uma excelente experiência de streaming. Comece hoje mesmo a sua jornada de filmes sem fim!</p>

                    <h2 className="content-title main-heading-title">Recursos do FMovies</h2>

                    <h3 className="content-title">Conteúdo de alta qualidade</h3>
                    <p>O FMovies é um lugar onde você pode assistir filmes online em alta qualidade, até 4K, sem travamentos. Todos os filmes incluem legendas e versões dubladas. Aproveite filmes em alta qualidade.</p>

                    <h3 className="content-title">Compatível com todos os dispositivos e fácil de usar</h3>
                    <p>Use este site em qualquer dispositivo, como TV, smartphone, laptop ou tablet. Encontre facilmente qualquer filme ou série com nossa interface limpa e intuitiva. Você também pode usar a busca para encontrar seu filme favorito rapidamente, digitando o nome.</p>

                    <h3 className="content-title">Biblioteca extensa e atualizações diárias</h3>
                    <p>FMovies possui uma vasta coleção de filmes e séries de TV com gêneros variados. Atualizamos o site diariamente para que você possa aproveitar os lançamentos mais recentes em exibição nos cinemas.</p>

                    <h3 className="content-title">Totalmente gratuito e ilimitado</h3>
                    <p>Nosso site é totalmente gratuito, sem necessidade de pagar ou assinar. Você pode assistir quantos filmes quiser sem comprometer a qualidade. Se quiser apoiar, compartilhe este site com seus amigos e familiares.</p>

                    <h3 className="content-title">Não é necessário instalar software</h3>
                    <p>FMovies é um site de streaming baseado na web, então você pode assistir a filmes e séries online sem instalar nenhum app ou software no seu dispositivo. Além disso, não é necessário criar conta nem fornecer dados pessoais.</p>

                    <h3 className="content-title">Anúncios mínimos</h3>
                    <p>Nosso site garante a melhor experiência de assistir a filmes, sem anúncios intrusivos que atrapalhem, permitindo que você se concentre totalmente no seu conteúdo.</p>

                    <h3 className="content-heading-h content-title">Categorias de busca no FMovies</h3>
                    <h4 className="content-heading-h">Filmes</h4>
                    <h4 className="content-heading-h">Séries de TV</h4>
                    <h4 className="content-heading-h">País de origem</h4>
                    <div>
                        <ol>
                            <li><p>Estados Unidos</p></li>
                            <li><p>Reino Unido</p></li>
                            <li><p>Países Baixos</p></li>
                            <li><p>África do Sul</p></li>
                            <li><p>Canadá</p></li>
                            <li><p>Índia</p></li>
                            <li><p>Austrália</p></li>
                            <li><p>Hungria</p></li>
                            <li><p>Bermuda</p></li>
                        </ol>
                    </div>
                    <h4 className="content-heading-h">Gêneros</h4>
                    <div>
                        <ol>
                            <li><p>Ação</p></li>
                            <li><p>Sci‑Fi</p></li>
                            <li><p>Comédia</p></li>
                            <li><p>Crime</p></li>
                            <li><p>Terror</p></li>
                            <li><p>Guerra</p></li>
                            <li><p>Thriller</p></li>
                            <li><p>Romance</p></li>
                            <li><p>História</p></li>
                            <li><p>Drama</p></li>
                            <li><p>Documentário</p></li>
                        </ol>
                    </div>

                    <h3 className="content-heading-h content-title">Principais alternativas éticas e legais ao FMovies</h3>
                    <div>
                        <ol>
                            <li><p><Link to="https://popcornflix.com.co/" className="link">Popcornflix</Link></p></li>
                            <li><p>123Movies</p></li>
                            <li><p>AZMovies</p></li>
                            <li><p>YouTube</p></li>
                            <li><p>Tubi</p></li>
                            <li><p>Crackle</p></li>
                            <li><p><Link to="https://www-hdtoday.com/" className="link">HDToday</Link></p></li>
                            <li><p>Peacock TV</p></li>
                            <li><p>Hurawatch</p></li>
                            <li><p>StreamM4u</p></li>
                            <li><p>Kanopy</p></li>
                        </ol>
                    </div>

                    <h3 className="content-title main-heading-title" id="faq">Perguntas Frequentes (FAQ)</h3>

                    <strong className="content-title">O que é o FMovies?</strong>
                    <p>Nosso site oferece a melhor experiência de assistir a filmes sem anúncios distrativos, permitindo que você se concentre totalmente no seu conteúdo.</p>

                    <strong className="content-title">O FMovies é seguro?</strong>
                    <p>Claro! A segurança dos usuários é nossa prioridade. FMovies é um site de streaming confiável. Assista sem preocupações. Apresentamos apenas anúncios limpos e seguros.</p>

                    <strong className="content-title">O FMovies oferece diferentes qualidades e legendas?</strong>
                    <p>Sim, a plataforma oferece qualidade de 360p, 720p, 1080p até 2K. Você pode escolher de acordo com sua conexão de internet. Para segurança extra, utilize VPN e antivírus confiáveis.</p>

                    <strong className="content-title">O FMovies possui filmes em todos os idiomas?</strong>
                    <p>Sim, atendemos audiências globais com filmes em várias línguas, com legendas.</p>

                    <strong className="content-title">Assistir filmes no FMovies é legal?</strong>
                    <p>Sim, assistir online é legal. Porém compartilhar conteúdo pirata é ilegal.</p>

                    <strong className="content-title">O FMovies é compatível com dispositivos móveis?</strong>
                    <p>Com certeza! FMovies funciona em todos os dispositivos e navegadores, incluindo tablets, computadores e celulares.</p>

                    <strong className="content-title">Existem limitações ao assistir filmes e séries?</strong>
                    <p>No FMovies, você pode assistir sem limites — tanto quanto quiser.</p>

                </div>
            </main>
            <Footer
                footerText="FMovies é o principal site de streaming gratuito. Oferece uma vasta coleção de conteúdos em vários gêneros e países. Sem anúncios intrusivos, sem necessidade de instalar app ou se registrar. FMovies proporciona uma ótima experiência para amantes de filmes e séries. Aproveite seus filmes favoritos gratuitamente, sem cadastro."
                currentPage={PT} />
        </>
    );
};

export default Index;

export const Head = () => (
    <>
        <html lang="pt" />
        <title>Fmovies - Assista Filmes online grátis</title>
        <meta
            name="description"
            content="Fmovies é um site de streaming popular que permite assistir Filmes e Séries online gratuitamente em qualidade HD, sem cadastro."
        />
        <meta name="robots" content="index,follow" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Fmovies" />
        <meta property="og:locale" content="pt" />
        <meta
            property="og:title"
            content="Fmovies - Assista Filmes online grátis"
        />
        <meta
            property="og:description"
            content="Fmovies é um site de streaming popular que permite assistir Filmes e Séries online gratuitamente em qualidade HD, sem cadastro."
        />
        <meta
            property="og:image"
            content="https://ww6-fmovies.com/screen.webp"
        />
        <meta property="og:url" content={PT} />
        <link rel="icon" href="https://ww6-fmovies.com/logo.png" />
        <link rel="canonical" href={PT} />

        <script type="application/ld+json">
            {JSON.stringify({
                "@context": "https://schema.org",
                "@type": "WebPage",
                "name": "Fmovies",
                "inLanguage": "pt",
                "description": "Fmovies é um site de streaming popular que permite assistir Filmes e Séries online gratuitamente em qualidade HD, sem cadastro.",
                "alternateName": "Assista Filmes HD online grátis",
                "image": "https://ww6-fmovies.com/screen.webp",
                "url": `https://ww6-fmovies.com${PT}`
            })}
        </script>
        <script type="application/ld+json">
            {JSON.stringify({
                "@context": "https://schema.org",
                "@type": "WebSite",
                "name": "Fmovies",
                "alternateName": "Assista Filmes HD online grátis",
                "url": `https://ww6-fmovies.com${PT}`,
                "headline": "Fmovies - Assista Filmes online grátis",
                "description": "Fmovies é um site de streaming popular que permite assistir Filmes e Séries online gratuitamente em qualidade HD, sem cadastro."
            })}
        </script>
        <script type="application/ld+json">
            {JSON.stringify({
                "@context": "https://schema.org",
                "@type": "Organization",
                "name": "Fmovies",
                "url": `https://ww6-fmovies.com${PT}`,
                "logo": "https://ww6-fmovies.com/logo.png",
                "sameAs": [
                    "https://play.google.com/store/apps/details?id=com.better.place",
                    "https://www.facebook.com/fmovies",
                    "https://twitter.com/fmovies",
                    "https://es.wikipedia.org/wiki/fmovies",
                    "https://ww6-fmovies.com/"
                ]
            })}
        </script>
        <Alternate />
    </>
);